import * as React from "react";
import { Alert } from "antd";
import { useCpFormValue } from "../../gvc/testNewForm/utils";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpKindSelect } from "../../gvc/testNewForm/temp/CpKindSelect";
import { CpRadioGroup } from "../../gvc/testNewForm/CpRadioGroup";
import { FormItem } from "../../../components/antd/form/FormItem";
import { FormItemValue } from "../../../components/antd/form/FormItemValue";
import { parseLink } from "../../../utils/linkParser/linkParser";

interface Props {
  /** If provided, locks the target based on the link type (gvc or workload) */
  lockedLink?: string;
}

export const IpSetSpecTarget: React.FC<Props> = ({ lockedLink }) => {
  const target = useCpFormValue("target");

  if (lockedLink) {
    const parsed = parseLink(lockedLink, { useInputCtx: true });
    const isWorkload = parsed.kind === "workload";
    const displayName = isWorkload
      ? (parsed.gvc ? `${parsed.gvc}/${parsed.name}` : parsed.name)
      : parsed.name;

    return (
      <>
        <FormItem>
          <CpLabel name="target">Target</CpLabel>
          <FormItemValue>{isWorkload ? "Workload" : "GVC"}</FormItemValue>
        </FormItem>
        <FormItem>
          <CpLabel name={isWorkload ? "workload" : "gvc"}>{isWorkload ? "Workload" : "GVC"}</CpLabel>
          <FormItemValue>{displayName}</FormItemValue>
        </FormItem>
      </>
    );
  }

  return (
    <>
      <CpFormItem>
        <CpLabel name="target">Target</CpLabel>
        <CpRadioGroup
          name="target"
          options={[
            { label: "GVC", value: "gvc" },
            { label: "Workload", value: "workload" },
          ]}
        />
        <CpErrorWarning name="target" />
      </CpFormItem>
      {target === "gvc" ? (
        <CpFormItem>
          <CpLabel name="gvc">GVC</CpLabel>
          <CpKindSelect key="gvc" kind="gvc" name="gvc" optionValue="name" style={{ maxWidth: 600 }} />
          <CpErrorWarning name="gvc" />
          <Alert
            showIcon
            className="my-1 w-fit"
            type="warning"
            message="Setting an ip set to a GVC will cause a temporary outage for all endpoints in this Workload."
          />
        </CpFormItem>
      ) : (
        <CpFormItem>
          <CpLabel name="workload">Workload</CpLabel>
          <CpKindSelect
            key="workload"
            kind="workload"
            name="workload"
            optionValue="relative"
            style={{ maxWidth: 600 }}
          />
          <CpErrorWarning name="workload" />
          <Alert
            showIcon
            className="my-1 w-fit"
            type="warning"
            message="Setting an ip set to a GVC will cause a temporary outage for all endpoints in this GVC."
          />
        </CpFormItem>
      )}
    </>
  );
};
